import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService, ButtonToolbarForm } from '../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { confirm } from 'devextreme/ui/dialog';
import { alert } from 'devextreme/ui/dialog';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaDataGridComponent } from '../../components/nica-data-grid/nica-data-grid.component';
@Component({
  selector: 'app-schedarifiuti',
  templateUrl: './schedarifiuti.component.html',
  styleUrls: ['./schedarifiuti.component.css']
})
export class SchedarifiutiComponent extends NicaMaster implements OnInit {
  @ViewChild('formSchedaRifiuto', { static: true }) formSchedaRifiuto: NicaAnagraficaComponent;
  @ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;
  @ViewChild('dataGrid', { static: false }) dataGrid: NicaDataGridComponent;

  @Input() itemData: any;
  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  bakgroundToolbar: any;
  filterGridLavorazione;
  filterGridMiscelazione;
  costantValues;
  IsNostra: boolean = false;
  schedaToolbar: ButtonToolbarForm[] = [
    {
      name: 'Schede di Cara',
      icon: 'glyphicon icon-documenti-form',
      displayMode: 'in-line',
      service: 'allegati',
      api: 'Allegati',
      path: '',
      templateComponent: '',
      componentName: 'AllegatiComponent',
      costantValue: [
        { key: 'nomeTabella', value: 'schedarifiuti' }
      ],
      hint: 'Lista allegati',
      event: '1',
      location: 'top',
      visible: true,
      disabled: false,
      wPopUp: "1000",
      hPopUp: "502",
      buttonSettings: {
        displayButtons:
        {
          typeOfConditions: '',
          arrayCondition: [
            { key: 'id', value: 0, operator: '>', }

          ],

        },


      }
    },

  ]
  templateTab: any = {
    SchedaRifiuto: 'grid',
    SchedaRifiutoLavorazione: 'gridLavorazione',
    SchedaRifiutoMiscelazione: 'gridMiscelazione'
  }
  selectedIndex: any =
    {

      SchedaRifiuto: 0,
      SchedaRifiutoLavorazione: 1,
      SchedaRifiutoMiscelazione: 2,

    }
  schedaTabs
  modifica: boolean = true;
  elimina: boolean = true;
  aggiungi: boolean = true;
  toolbarSchedaLavorazioneButton: any = [];
  tableWidth: number;
  titleLavorazioneMiscelazione: string;
  schedaRifiutoRow: any;

  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );


  }


  ngOnInit() {

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.setTabsScheda();
      this.buttonToolbarBottomGrid = [0]
      
      if (this.itemData[0].onlyRead) {
        this.aggiungi = false;
        this.elimina = false;
        this.modifica = false
      }



    } else {

      this.activateRoute.queryParams.subscribe((params) => {
        this.params = params

        this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName

      

        this.setGlobalVariableFromParams(params);

        if (!this.filterID['isEdit']) {
          this.setTabsScheda()
        }
        this.buttonToolbarBottomGrid = [0]
        
        
        this.toolbarSchedaLavorazioneButton = [
         
          {
            id: 'CopiaDaSchedaEsistente',
            name: 'Inserisci da scheda rifiuto esistente',
            text: 'Inserisci da scheda rifiuto esistente',
            icon: 'glyphicon mdi mdi-content-copy',
            disabled: false,
            visible: true,
            widget: 'button',
           
          },
        ]

        if (this.template == 'gridLavorazione') {
          
          this.IsNostra = this.filterID['produttore_NostraAzienda'];
          this.setTabsScheda();
          this.titleLavorazioneMiscelazione = 'Elenco E.E.R che incidono in % nella lavorazione'
          this.tableWidth = 1300;
          
          this.costantValues = [
            { key: 'idProduttore', value: this.filterID['idProduttore'] },
            { key: 'idSchedaRifiuto', value: this.filterID['idSchedaRifiuto'] },
            { key: 'cerRiferimento', value: this.filterID['cerRiferimento'] },
          ]

          this.filterGridLavorazione = "/" + this.filterID['idSchedaRifiuto']
          this.rowData['idProduttore']    = this.filterID['idProduttore'];
          this.rowData['idSchedaRifiuto'] = this.filterID['idSchedaRifiuto'];
          this.impostaTitoloForm(this.anagraficaDati);
        }
        
        if (this.template == 'gridMiscelazione') {
          
          this.titleLavorazioneMiscelazione = 'Elenco E.E.R che incidono in % nella miscelazione'
          this.IsNostra = this.filterID['produttore_NostraAzienda'];

          this.setTabsScheda();
          this.tableWidth = 1000;
          this.impostaTitoloForm(this.anagraficaDati);
          
          this.costantValues = [
            { key: 'idProduttore', value: this.filterID['idProduttore'] },
            { key: 'idSchedaRifiuto', value: this.filterID['idSchedaRifiuto'] },
            { key: 'cerRiferimento', value: this.filterID['cerRiferimento'] },
          ]

          //this.filterGridMiscelazione = "/" + this.filterID['idSchedaRifiuto']

          this.filterGridLavorazione = "/" + this.filterID['idSchedaRifiuto']
          this.rowData['idProduttore']    = this.filterID['idProduttore'];
          this.rowData['idSchedaRifiuto'] = this.filterID['idSchedaRifiuto'];
          this.rowData['cerRiferimento'] = this.filterID['cerRiferimento'];
        }


        if (!params.data)
          return;


      });

    }

    if (typeof this.itemData != 'undefined') {

      this.template = this.itemData[0].template;



    }



  }

  gridEventMiscelazione(e) {
    if (e.name == 'selectedDinamicGrid') {
      if (e.parentComponent.dataField == 'descrizioneSch') {
        setTimeout(() => {
          let FormX = e.masterComponent;
          FormX.updateData('eer', e.selectRow['eer']);
          FormX.updateData('idStatoFisico', e.selectRow['idStatoFisico']);
          FormX.updateData('riferimentoEER', e.selectRow['riferimentoEER']);
          //this.settaFormPerScheda(e,true)
          //FormX.refresh();
        }, 200);
      }
    }
  }

  formDataSource(e) {

    this.filterID['produttore_NostraAzienda'] = e.formData.produttore_NostraAzienda;
    this.IsNostra = e.formData.produttore_NostraAzienda;

    this.setTabsScheda()
  }

  settaFormPerScheda(e, flag) {
    let FormX = e.masterComponent;
    let editorUploadButton = FormX.getEditor("eer");

    FormX.itemOption('datiLavorazione.eer', "disabled", flag);
    FormX.itemOption('datiLavorazione.descrizioneCer', "disabled", flag);
    FormX.itemOption('datiLavorazione.riferimentoEER', "disabled", flag);
    FormX.itemOption('datiLavorazione.idStatoFisico', "disabled", flag);

    if (!flag) {
      /*  FormX.itemOption('datiLavorazione.eer',"validationRules", null);
       FormX.itemOption('datiLavorazione.descrizioneCer',"validationRules", null);
       FormX.itemOption('datiLavorazione.riferimentoEER',"validationRules", null);
       FormX.itemOption('datiLavorazione.idStatoFisico',"validationRules", null);    */
      FormX.dataSet['eer'] = null;
      FormX.dataSet['descrizioneCer'] = null;
      FormX.dataSet['riferimentoEER'] = null;
      FormX.dataSet['idStatoFisico'] = null;
      FormX.dataSet['descrizione_idStatoFisico'] = null;
      FormX.dataSet['isCerPericoloso'] = null;

    }


  }

  gridEventScheda(e) {
    console.log("EVENTOOOOOOOOOO IN gridEventScheda ", e)
  }

  gridEventLavorazione(e) {
 
    if (e.name == 'onValueChange' || e.name == 'onValueChanged') {
      if (e.campo.dataField == 'idSchedaRifiutoRow') {
        //alert("vattela")
      }


    }
    if(e.name == 'toolbarButtonClick'){
      console.log("EVENTOOOOOOOOOO DA NICA FORM ", e)
      if( e.infoEventButtons==='CopiaDaSchedaEsistente')
        this.showOtherSchedeRifiuti()
    }


    if (e.name == 'valueDifferent' || e.name == 'onValueChange' || e.name == 'onValueChanged') {
      if (e.campo.dataField == 'idSchedaRifiuto' && e.value != null) {

        this.settaFormPerScheda(e, true);
      }
      if (e.campo.dataField == 'idSchedaRifiuto' && e.value == null) {

        this.settaFormPerScheda(e, false);

      }

    }
    
    if (e.name == 'selectedDinamicGrid') {
      //datiLavorazione gg 
      if (e.parentComponent.dataField == 'descrizioneSch') {


        setTimeout(() => {
          let FormX = e.masterComponent;
          FormX.updateData('eer', e.selectRow['eer']);

          FormX.updateData('idStatoFisico', e.selectRow['idStatoFisico']);
          FormX.updateData('riferimentoEER', e.selectRow['riferimentoEER']);
          FormX.updateData('eer', e.selectRow['eer']);
          FormX.updateData('idStatoFisico', e.selectRow['idStatoFisico']);
          FormX.updateData('riferimentoEER', e.selectRow['riferimentoEER']);
          this.settaFormPerScheda(e, true)

          //idSchedaRifiutoRow
          //descrizioneSch

          //eer
          //descrizioneCer
          //riferimentoEER
          //idStatoFisico


          //FormX.refresh();

        }, 200);


        //Form.dataSet['eer']=''
        //Form.updateData('eer',e.selectRow['eer']);

      }

      if (e.name == "onInitNewRow") {

        e.cancel = true;

      }
    }
   
    if(e.name == 'startingRowEditor'){
     
        e.data.eer = this.schedaRifiutoRow['eer']
        const rowIndex = e.rowIndex
        let data = this.dataGrid.editorData[rowIndex]['data']
        
        data['idSchedaRifiutoRow'] = this.schedaRifiutoRow['id'];
        data['eer'] = this.schedaRifiutoRow['eer'];
        data['idStatoFisico'] = this.schedaRifiutoRow['idStatoFisico'];
        data['riferimentoEER'] = this.schedaRifiutoRow['riferimentoEER'];

       
       
        
        setTimeout(() => {
          this.schedaRifiutoRow = null
        });
      
      
      //console.log('schedaRifiutoRow-->',this.schedaRifiutoRow)
    }

  }

  setTabsScheda() {

    this.selectedIndex[this.SubjectCall];

    let data = [];



    this.schedaTabs = [

      {
        name: 'Scheda Rifiuto',
        icon: 'glyphicon icon-albo-form',
        hint: 'scheda ripilogativa con analisi chimico fisica del riufiuto',
        displayMode: 'in-line',
        path: 'main/schede-descrittive-rifiuti',
        componentName: 'SchedarifiutiComponent',
        service: 'SchedaRifiuto',
        api: 'SchedaRifiuto',
        templateComponent: this.templateTab['SchedaRifiuto'],
        visible: true,
        disabled: false,


      },
      {
        name: 'Scheda Lavorazione',
        icon: 'glyphicon icon-albo-form',
        hint: 'Autorizzazione carrozzerie mobili',
        displayMode: 'in-line',
        path: 'main/schede-descrittive-rifiuti',
        componentName: 'SchedarifiutiComponent',
        service: 'SchedaRifiutoLavorazione',
        api: 'SchedaRifiuto',
        templateComponent: this.templateTab['SchedaRifiutoLavorazione'],
        visible: true,
        disabled: this.IsNostra ? false : true

      },

      {
        name: 'Scheda Miscelazione',
        icon: 'glyphicon icon-albo-form',
        hint: 'Scheda Miscelazione',
        displayMode: 'in-line',
        path: 'main/schede-descrittive-rifiuti',
        componentName: 'SchedarifiutiComponent',
        service: 'SchedaRifiutoMiscelazione',
        api: 'SchedaRifiutoMiscelazione',
        templateComponent: this.templateTab['SchedaRifiutoMiscelazione'],
        visible: true,
        disabled: this.IsNostra ? false : true
      },
    ]

  }

  tabClick(ev) {

    const itemData = ev.itemData;

    let filterID = { ...this.filterID }

    if (this.formAnagrafica) {
      if (this.formAnagrafica.dataSet)
        if (!this.formAnagrafica.validate().isValid && itemData.service !== 'SchedaRifiuto')
          return;
      //(document.getElementsByClassName('dx-icon glyphicon icon-salva-form').item(0))    
      this.formAnagrafica.onFormSubmit();
    }

    //(jQuery.event as any).trigger({ type: 'keydown', which: 78 })

    //this.filterID['templateTab'] = this.templateTab;

    if (itemData.service == this.SubjectCall) {
      return
    }

    let data = [];

    if (this.template == 'form') {
    
    }
    
    const dataTo =  !this.formAnagrafica ?  this.filterID : this.formAnagrafica.dataSet;
    
    const queryFilter = this.anagraficaDati[0]['configuration']['queryFilter'];
    this.addDataToFilterID(dataTo,queryFilter);
    
    if(itemData.service === 'SchedaRifiuto'){
     
      itemData.templateComponent = 'form';
      this.filterID['isEdit']= true

      delete this.filterID['idSchedaRifiuto'],
      delete this.filterID['idProduttore'];
      delete this.filterID['produttore_NostraAzienda'];
      delete this.filterID['produttore_DescrizioneSoggetto'];
      delete this.filterID['cerRiferimento'];
    }
   
    
    data = this.filterID;
    this.refreshPage(data, '', itemData.service, itemData.templateComponent);
  }
  
  formEventMiscelazione(e) {

    console.log("Sono in form event Lavorazione", e)
  }

  formEventLavorazione(e) {

    console.log("Sono in form event Lavorazione", e)
  }
  
  AbilDisabledAdr(e) {
    setTimeout(() => {
      let editor = e.component.getEditor("testoADR");
      editor.option("disabled", !e.value);

      editor = e.component.getEditor("idClasseAdr");
      editor.option("disabled", !e.value);

      editor = e.component.getEditor("idClasseAdr");
      editor.option("disabled", !e.value);
      editor = e.component.getEditor("idOnu");
      editor.option("disabled", !e.value);

      if (e.value == false) {
        this.formAnagrafica.formEdit.instance.updateData('testoADR', null);
        this.formAnagrafica.formEdit.instance.updateData('idClasseAdr', null);
        this.formAnagrafica.formEdit.instance.updateData('idOnu', null);
        this.formAnagrafica.formEdit.instance.updateData('idTestoAdr', null);
      }

    }, 1);

  }

  private isNotEmpty(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  formEvent2(e) {
    //formDataInit formContentInitializzed formContentReady
    // beforeMitter valueDifferent
    if (e.name == 'onValueChanged' && e.campo.dataFiled == 'eer') {
      if (e.previousValue) {
        this.formAnagrafica.formEdit.instance.updateData('testoADR', null);
        this.formAnagrafica.formEdit.instance.updateData('idClasseAdr', null);
        this.formAnagrafica.formEdit.instance.updateData('idOnu', null);
        this.formAnagrafica.formEdit.instance.updateData('idTestoAdr', null);
      }
    }
    if (e.name == 'beforeMitter' && e.campo.dataField == 'testoADR') {
      if (!this.isNotEmpty(e.formData.eer)) {
        alert("Devi Selezionare prima il codice EER", "Notifica");
        e.cancel = true
      }

    }
    if (e.name == 'formContentReady') {
      let isAdr = e.formData.isADR;
      e.value = e.formData.isADR;
      e.component = e.masterComponent;
      this.AbilDisabledAdr(e);
    }
    if (e.name == 'formContentInitializzed') {

    }

    //"formContentReady" formContentInitializzed
    console.log("Sono in form event ", e)
    //"valueDifferent"
    if (e.name == 'radioValueChanged') {

      //let FormX = e.masterComponent; quantitaPrevista

      let filter = '[["descrizioneScheda", "contains", "{{descrizioneScheda}}"],"and",["quantitaPrevista", ">", {{quantitaPrevista}}],[["idTipoRaee", "=", "{{idTipoRaee}}"],"or",["idTipoRaee", "=", "{{idTipoRaee}}"]]]'


      /* this.formAnagrafica.generaOdata().then(result=>{
        result="$filter="+result
        console.log("ODATA RESULT ",result);
      }) */


      this.AbilDisabledAdr(e);
    }

    if (e.name == 'valueDifferent' && e.campo.dataField == 'idProduttore' && e.formData.id > 0) {
      if (e.previousValue != null) {

        if (e.formData.nsAzienda == false) {

          confirm("<i><strong>ATTENZIONE!! Eventuali schede di lavorazione o miscelazione verranno eliminate.</br><p style='text-align: center;font-weight: bold;'>Vuoi Procedere?</p></strong></i>", "Schede Tecniche").then(res => {
            if (res == false) {
              let FormX = e.masterComponent;
              FormX.updateData('idProduttore', e.previousValue);
            }
          })




        }

      }
    }
    if (e.name == 'formDataChanged' && e.formDataChanged) {

      this.schedaTabs[1]['disabled'] = (e.formDataChanged.id == undefined || e.formDataChanged.id < 1 || e.formDataChanged.nsAzienda === false || e.formDataChanged.nsAzienda == null || e.formDataChanged.idProduttore < 1 || e.formDataChanged.idProduttore == undefined);
      this.schedaTabs[2]['disabled'] = (e.formDataChanged.id == undefined || e.formDataChanged.id < 1 || e.formDataChanged.nsAzienda === false || e.formDataChanged.nsAzienda == null || e.formDataChanged.idProduttore < 1 || e.formDataChanged.idProduttore == undefined);
    }
    if (e.eventName == 'submittedInsertOk') {
      this.id = e[this.masterKey];
      let data = e
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });
      }
      this.refreshPage(e, 'Modifica', this.SubjectCall, 'form');
    }

    if (e.eventName == 'submittedEditOk') {
      let data = this.formAnagrafica.dataSet;
      /**Gestisco i queryurl Filtri in Base al Edit**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });
      }
      this.refreshPage(data, 'Modifica', this.SubjectCall, 'form');
    }
    if (e.name == 'return') {

      let data = [];
      /**Gestisco i queryurl Filtri in Base al filtri iniziali**/
      if (this.anagraficaDati[0]['configuration']['queryFilter']) {
        let arrayIdRif = this.anagraficaDati[0]['configuration']['queryFilter'] // prendo i campi di riferimento da passare alla Form dalla configurazione
        let newItem
        let data = this.formAnagrafica.dataSet
        //let data = this.filterID
        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            newItem = { ...this.filterID, [idTab['key']]: data[idTab['value']] };
            this.filterID = newItem;
          }
        });
      }
      this.refreshPage('', 'Elenco', this.SubjectCall, 'grid');
    }
    if (e.name == 'formDataInit') {
      this.currentElement = e.formData
    }
    if (e.name == 'formContentInitializzed') {
      this.SetToolbarButtons(this.serviceButtonsArray, e.formData);
    }


  }

  emettiChiusuraLavorazioneMiscelazione(ev){
    if(this.SubjectCall !== 'SchedaRifiuto'){
      this.returnUrlBy();
      return
    }
    this.emettiChiusuraCaption(ev)  
  }

  formItemsEventScheda(event) {

    if (event.name == "selectedItemLista") {
      if (event.campo.dataField == "isADR") {

        if (event.value) {

          setTimeout(() => {
            
            this.formAnagrafica.itemOption('datiBase.descrizione_IdTestoAdr', 'disabled', false);
            this.formAnagrafica.itemOption('datiBase.idClasseAdr', 'disabled', false);
            this.formAnagrafica.itemOption('datiBase.idOnu', 'disabled', false);
           
          }, 300);
        } else {
          
          setTimeout(() => {

            this.formAnagrafica.itemOption('datiBase.descrizione_IdTestoAdr', 'disabled', true);
            this.formAnagrafica.itemOption('datiBase.idClasseAdr', 'disabled', true);
            this.formAnagrafica.itemOption('datiBase.idOnu', 'disabled', true);

            this.formAnagrafica.formRefreshInputData('descrizione_IdTestoAdr', null)
            this.formAnagrafica.formRefreshInputData('idTestoAdr', null)
            this.formAnagrafica.formRefreshInputData('idClasseAdr', null)
            this.formAnagrafica.formRefreshInputData('idONU', null);
          
          }, 300);
        }


      }
    }
    if(event.name == 'beforeMitter' && event.campo.dataField == 'idRecup'){
      const formData = event.formData
      
      if (!formData.eer) {
        event.cancel = true;
        alert('Seleziona prima il codice EER', 'Attenzione');
        return
      }
    }
    //console.log('formItemsEventScheda',event)
    
  }

  showOtherSchedeRifiuti() {


   
    let cerRiferimento =  this.filterID['cerRiferimento']
    
    let queryString = `?$filter=idProduttore gt 0 and eer ne '${cerRiferimento}'`
    

    let instancedDataGrid = {
      service:null,
      api: 'SchedaRifiuto',
      remoteOperation:true,
      rowAlternate: true,
      queryString: queryString,
      isEditable: false,
      isEditableNewRow:false,
      isEditableEditRow:false,
      isEditableDeleteRow:false,
      tableHeight: 500,
      tableWidth: 600,
      showFilter: false,
      colonne: [
        {
          type: 'campo',
          dataField: "eer",
          caption: "EER",
          colWidth:70,
        },
        {
          type: 'campo',
          dataField: "idStatoFisico",
          caption: "SF",
          colWidth:50,
        },
        {
          type: 'campo',
          dataField: "riferimentoEER",
          caption: "Rif.EER",
          colWidth:100,
        },
        {
          type: 'campo',
          dataField: "produttore_DescrizioneSoggetto",
          caption: "Produttore",
          colWidth:200,
        },
      ],
      selectionRowMode: 'single',
      selectedData: null,
      isOdata:true,
      idTable: 'SchedaRifiuto',
      showToolbarTop: false,
      showToolbarBottom: false,
      isSearchable: true,
      
    }


    let guid = this.openComponentInPopUP('NicaDataGridComponent',[],instancedDataGrid,'600','Elenco schede rifiuti',true,true);

    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null,'600',null,instancedDataGrid,true,true, 'Elenco carrozzerie autorizzate');
    this.userComponentService.outputComponent.subscribe(currentOutput => {

        console.log('currentOutput',currentOutput)
        let eData
        if(currentOutput.name == "onRowSelectionChange" && guid == currentOutput.guid){
        
          this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
          
            this.schedaRifiutoRow = currentOutput.data;
          //this.nicaDataGrid.editorData[rowIndex]['data'].legaChiudi = false
            this.dataGrid.addRow()
            console.log('onRowSelectionChange-->',currentOutput)

        }

        if(currentOutput.name == 'startingRowEditor' && guid == currentOutput.guid){
          console.log('startingRowEditor-->',currentOutput)
          console.log('eDataRowEditor-->',eData)
        }
    })




    return

   
  }

  

}
